export const NAME = "reportForm";



// WEBPACK FOOTER //
// ./client/modules/ReportForm/constants.js